import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.32474 5.48192C8.32474 7.42488 6.77716 8.96383 4.91237 8.96383C3.04758 8.96383 1.5 7.42488 1.5 5.48192C1.5 3.53896 3.04758 2 4.91237 2C6.77716 2 8.32474 3.53896 8.32474 5.48192ZM7.25494 9.86197C6.55865 10.2458 5.76062 10.4638 4.91237 10.4638C2.19934 10.4638 0 8.23335 0 5.48192C0 2.73048 2.19934 0.5 4.91237 0.5C7.6254 0.5 9.82474 2.73048 9.82474 5.48192C9.82474 6.77007 9.34267 7.94404 8.55151 8.82839L11.7602 12.0826C12.08 12.4068 12.08 12.9325 11.7602 13.2568C11.4405 13.5811 10.9221 13.5811 10.6024 13.2568L7.25494 9.86197Z",
      fill: "#1F2D43"
    }, null, -1)
  ]))]))
}
export default { render: render }